import { CheckBoxIcon, SyncDesktopIcon } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'

interface TestCaseSelectionBarProps {
  selectedCount: number
  onCancel: () => void
  onPush?: () => void
  pushDisabled?: boolean
  pushDisabledReason?: string
}

export function TestCaseSelectionBar({
  selectedCount,
  onCancel,
  onPush,
  pushDisabled,
  pushDisabledReason,
}: TestCaseSelectionBarProps) {
  if (selectedCount === 0) return null

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2 rounded-2xl border border-border-accent bg-background px-4 py-2 shadow-lg"
      role="region"
      aria-label="Selection actions"
      data-testid="test-case-selection-bar"
    >
      <div className="flex items-center gap-2 pr-3 border-r">
        <CheckBoxIcon className="h-4 w-4" />
        <span className="text-sm font-medium" data-testid="test-case-selection-count">
          {selectedCount} selected
        </span>
      </div>
      {onPush && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="gap-2"
          onClick={onPush}
          disabled={pushDisabled}
          title={pushDisabled ? pushDisabledReason : undefined}
          data-testid="test-case-bulk-push"
        >
          <SyncDesktopIcon className="h-4 w-4" />
          Push to Azure DevOps
        </Button>
      )}
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="gap-2"
        onClick={onCancel}
        data-testid="test-case-selection-cancel"
      >
        <X className="h-4 w-4" />
        Cancel
      </Button>
    </div>
  )
}
